<form name="form" #f="ngForm" (ngSubmit)="
  !f.form.valid
  ? accordion.openAll()
  : 'true' && f.form.valid && onSign()
  ">
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{'update_enterprise.screen_name_new' | translate}}: {{oldEnterpriseName}}
        <!-- <small class="form-text text-gray pull-left pb-2 float-right">{{'update_enterprise.lbl_info' |
          translate}}
        </small> -->
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <!-- Thông tin doanh nghiệp -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title" style="display: flex; justify-content: space-between;">
              {{'title.enterprise_info'| translate}}
              <small class="form-text text-gray pull-left pb-2 float-right">{{'update_enterprise.lbl_info' |
                translate}}
              </small>
            </mat-panel-title>

          </mat-expansion-panel-header>

          <div class="row">
            <!-- Tên đăng nhập -->
            <!-- <div class="col-md-4">
              <mat-label>
                <small>{{'update_enterprise.enterprise_info.lbl_user_name' | translate}}</small>
                <p matTooltip="{{enterprises.adminUser}}" class="dotted fix-width">{{enterprises.adminUser}}</p>
              </mat-label>
            </div> -->

            <!-- Tên đơn vị -->
            <div class="col-md-12">
              <mat-form-field class="w-100">
                <mat-label>{{(enterprises.enterpriseType == personalId?
                  'form.full_name'
                  :'search_form.enterprise_name')| translate}}</mat-label>
                <input #focusInput matInput type="text" autocomplete="off" name="name" #name="ngModel"
                  (focusout)="enterprises.name=enterprises.name.trim()" [(ngModel)]="enterprises.name" required
                  maxlength="200" [placeholder]="(enterprises.enterpriseType == personalId)?
                  ('form.full_name'| translate)
                  :('search_form.enterprise_name'| translate)" />
                <button mat-button *ngIf="enterprises.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="enterprises.name=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="name.invalid && name?.errors?.required">
                  {{(enterprises.enterpriseType == personalId?
                  'update_enterprise.enterprise_info.lbl_validation_person'
                  :'update_enterprise.enterprise_info.lbl_validation_enterprise')| translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Loại doanh nghiệp (Nếu không phải chi nhánh) -->
            <!-- <div class="col-md-4" *ngIf="!enterprises.parentId">
              <mat-form-field class="w-100">
                <mat-label>{{'update_enterprise.enterprise_info.cbx_enterprise_type.lbl_enterprise_type' | translate }}
                </mat-label>
                <mat-select #enterpriseTypeSelect (focusout)="(checkFocus = true)"
                  (focus)="commonService.openComboBox(checkFocus, enterpriseTypeSelect)" id="type" name="type"
                  [(ngModel)]="enterprises.enterpriseType" #type="ngModel" required
                  (selectionChange)="checkFocus = false; enterprises.certificateId = null;">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="enterpriseTypeFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let enterprise of filteredEnterpriseType | async" [value]="enterprise.id"
                    (click)="this.commonService.closeDropdownList(this.enterpriseTypeSelect)"
                    title="{{getEnterpriseTypeOptions(enterprise.langs)}}">
                    {{getEnterpriseTypeOptions(enterprise.langs)}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="type.invalid && type?.errors?.required">
                  {{ 'update_enterprise.validation.lbl_validation_enterprise_type' | translate }}
                </mat-error>
              </mat-form-field>
            </div> -->

            <!-- Ngày sinh (Nếu là doanh nghiệp cá nhân) -->
            <div class="col-md-4" *ngIf="enterprises.enterpriseType == personalId">
              <mat-form-field class="w-100">
                <input matInput autocomplete="off" (dateInput)="addEvent( $event)" [matDatepicker]="birthday2"
                  name="birthday" [(ngModel)]="enterprises.birthday" (dateInput)="addEvent($event)"
                  (dateChange)="addEvent($event)" maxlength="10" #birthday="ngModel" #pickerInput2 [max]="maxDate"
                  (change)="this.commonService.resetDatePicker(pickerInput2.value, this.ngForm.controls['birthday'])"
                  [placeholder]="'form.birthday' | translate" />
                <mat-datepicker-toggle matSuffix [for]="birthday2"></mat-datepicker-toggle>
                <mat-datepicker #birthday2></mat-datepicker>
                <mat-error *ngIf="f.submitted || birthday.invalid">
                  {{getErrorDateMessage(pickerInput2.value)}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Giới tính (Nếu là doanh nghiệp cá nhân) -->
            <!-- <div class="col-md-4" *ngIf="enterprises.enterpriseType == personalId">
              <mat-form-field class="w-100">
                <mat-label>{{'form.sex' | translate}}</mat-label>
                <mat-select #sexSelect1 (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, sexSelect1)" id="sex" name="sex"
                  [(ngModel)]="enterprises.sex">
                  <mat-option [value]="true" (click)="this.commonService.closeDropdownList(this.sexSelect1)">
                    {{'form.male' | translate}}</mat-option>
                  <mat-option [value]="false" (click)="this.commonService.closeDropdownList(this.sexSelect1)">
                    {{'form.female' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div> -->

            <div class="col-md-4" *ngIf="enterprises.enterpriseType == personalId">
              <mat-label style="color: #858796">{{'form.sex' | translate}}</mat-label><br>
              <mat-radio-group #sexSelect1 id="sex" name="sex" [(ngModel)]="enterprises.sex">
                <mat-radio-button [value]="true" class="pt-2 mr-3">{{'form.male' | translate}}</mat-radio-button>
                <mat-radio-button [value]="false">{{'form.female' | translate}}</mat-radio-button>
              </mat-radio-group>
            </div>

            <!-- Loại Giấy tờ -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>
                  {{ 'update_enterprise.enterprise_info.cbx_type_certification.lbl_type_certification' | translate }}
                </mat-label>
                <mat-select #certificationTypeSelect (focusout)="(checkFocus = true)"
                  (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, certificationTypeSelect)" id="certificateId"
                  name="certificateId" #certificateId="ngModel" [(ngModel)]="enterprises.certificateId"
                  [required]="enterprises.parentId" [disabled]="true">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate"
                      [formControl]="enterprises.enterpriseType == personalId ? representativeCertificateTypeFilterCtrl : certificationTypeFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let certificate of (enterprises.enterpriseType == personalId ? filteredRepresentativeCertificateType : filteredCertificationType) | async"
                    [value]="certificate.id"
                    (click)="this.commonService.closeDropdownList(this.certificationTypeSelect)">
                    {{getEnterpriseTypeOptions(certificate.langs)}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="certificateId.invalid && certificateId?.errors?.required">
                  {{ 'update_enterprise.validation.lbl_validation_type' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Số giấy tờ -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.enterprise_info.lbl_gpkd' | translate }}</mat-label>
                <input matInput type="text" name="certificateNo" #certificateNo="ngModel"
                  (focusout)="enterprises.certificateNo = enterprises.certificateNo.trim()"
                  [(ngModel)]="enterprises.certificateNo" [ngClass]="{
                      'is-invalid': certificateNo.invalid
                    }" [required]="enterprises.parentId" maxlength="20" [placeholder]="'form.gpkd' | translate"
                  #certificateNoEl [disabled]="true" />
                <button mat-button *ngIf="enterprises.certificateNo" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.certificateNo=''" [disabled]="true">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="certificateNo.invalid && certificateNo?.errors?.required">
                  {{ 'update_enterprise.validation.lbl_validation_gpkd' | translate }}
                </mat-error>
                <mat-error *ngIf="certificateNo.invalid && certificateNo?.errors?.validInput">
                  {{ 'update_enterprise.validation.lbl_validation_gpkd_format' | translate }}
                </mat-error>
                <mat-error *ngIf="certificateNo.invalid && certificateNo?.errors?.duplicate">
                  {{ 'update_enterprise.validation.lbl_validation_gpkd_duplicate' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Ngày cấp -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.enterprise_info.lbl_issued_date' | translate }}</mat-label>
                <input matInput [matDatepicker]="issuedDate1" [max]="maxDate" name="issuedDate" #issuedDate="ngModel"
                  [(ngModel)]="enterprises.issuedDate" [ngClass]="{ 'is-invalid': issuedDate.invalid }"
                  [required]="enterprises.parentId" maxlength="10" #pickerInput (dateInput)="addEvent($event)"
                  (dateChange)="addEvent($event)" [placeholder]="'form.issued_date' | translate"
                  (keyup)="checkIssuedDateChange(pickerInput.value)" />
                <mat-datepicker-toggle matSuffix [for]="issuedDate1"></mat-datepicker-toggle>
                <mat-datepicker #issuedDate1></mat-datepicker>
                <mat-error *ngIf="issuedDate.invalid">{{ getErrorDateMessage(pickerInput.value) }}
                </mat-error>
                <mat-error *ngIf="issuedDate.invalid && checkIssuedDate">
                  {{ 'update_enterprise.validation.lbl_validation_issued_date' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Nơi cấp -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.enterprise_info.lbl_issued_by' | translate }}</mat-label>
                <input matInput type="text" name="issuedAt" #issuedAt="ngModel" [(ngModel)]="enterprises.issuedAt"
                  (focusout)="enterprises.issuedAt=enterprises.issuedAt.trim()"
                  [ngClass]="{ 'is-invalid': issuedAt.invalid }" [required]="enterprises.parentId" maxlength="200"
                  [placeholder]="'form.issued_by' | translate" />
                <button mat-button *ngIf="enterprises.issuedAt" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.issuedAt=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="issuedAt.invalid && issuedAt?.errors?.required">
                  {{'update_enterprise.validation.lbl_validation_issued_by' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Mã số thuế -->
            <div class="col-md-4"
              *ngIf="enterprises.enterpriseType != personalId || enterprises.enterpriseType == null">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.enterprise_info.lbl_tax_code' | translate }}</mat-label>
                <input matInput autocomplete="off" type="text" [required]="enterprises.parentId" name="taxCode"
                  (focusout)="enterprises.taxCode=enterprises.taxCode.trim()" id="taxCodeid" #taxCode="ngModel"
                  [(ngModel)]="enterprises.taxCode" [maxlength]="taxCodeMaxlength"
                  [ngClass]="{ 'is-invalid': taxCode.invalid }" [placeholder]="'form.tax_code' | translate"
                  [disabled]="checkTax" required maxlength="20">
                <button mat-button *ngIf="enterprises.taxCode" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.taxCode=''" [disabled]="checkTax">
                  <mat-icon>close</mat-icon>
                </button>
                <!-- <mat-error *ngIf="taxCode.invalid && taxCode?.errors?.validIp">
                  {{'update_enterprise.validation.lbl_validation_tax_code_number' | translate}}
                </mat-error> -->
                <!-- <mat-error *ngIf="taxCode.invalid">
                  {{'update_enterprise.validation.lbl_validation_tax_code_required' | translate}}
                </mat-error> -->
                <mat-error *ngIf="taxCode.invalid && taxCode?.errors?.duplicate">
                  {{'update_enterprise.validation.lbl_validation_tax_code_duplicate' | translate}}
                </mat-error>
                <mat-error *ngIf="f.submitted || taxCode?.errors?.required">
                  {{'validation.code_tax_request' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin người đại diện -->
        <mat-expansion-panel expanded="true"
          *ngIf="enterprises.enterpriseType != personalId || enterprises.enterpriseType == null">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title" style="display: flex; justify-content: space-between;">
              {{'update_enterprise.representative_info.ttl_representative_info' | translate}}
              <small class="form-text text-gray pull-left pb-2 float-right">{{'update_enterprise.lbl_info' |
                translate}}
              </small>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row">
            <!-- Tên người đại diện -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.representative_info.lbl_full_name' | translate }}</mat-label>
                <input matInput type="text" name="representative" #representative="ngModel"
                  (focusout)="enterprises.representative=enterprises.representative.trim()"
                  [(ngModel)]="enterprises.representative" required maxlength="200" [ngClass]="{
                    'is-invalid': representative.invalid
                  }" [placeholder]="'form.fullname' | translate" />
                <button mat-button *ngIf="enterprises.representative" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.representative=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="representative.invalid && representative?.errors?.required">
                  {{'update_enterprise.validation.lbl_validation_representative' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Chức vụ -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.representative_info.lbl_position' | translate }}</mat-label>
                <input matInput type="text" name="position" #position="ngModel" [(ngModel)]="enterprises.position"
                  (focusout)="enterprises.position=enterprises.position.trim()"
                  [ngClass]="{ 'is-invalid': position.invalid }" required maxlength="200"
                  [placeholder]="'form.position' | translate" />
                <button mat-button *ngIf="enterprises.position" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.position=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="position.invalid && position?.errors?.required">
                  {{'update_enterprise.validation.lbl_validation_postion' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Loại giấy tờ -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>
                  {{ 'update_enterprise.representative_info.cbx_type_certification.lbl_type_certification' | translate
                  }}
                </mat-label>
                <mat-select #representativeCertificateSelect (focusout)="(checkFocus = true)"
                  (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, representativeCertificateSelect)"
                  id="representativeCertificateId" name="representativeCertificateId"
                  [(ngModel)]="enterprises.representativeCertificateId" value="enterprises.representativeCertificateId">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate"
                      [formControl]="representativeCertificateTypeFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let representativeCertificateType of filteredRepresentativeCertificateType | async"
                    [value]="representativeCertificateType.id"
                    (click)="this.commonService.closeDropdownList(this.representativeCertificateSelect)">
                    {{getEnterpriseTypeOptions(representativeCertificateType.langs)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Số giấy tờ -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.representative_info.lbl_certification_no' | translate }}</mat-label>
                <input matInput type="text" name="representativeCertificateNo"
                  (focusout)="enterprises.representativeCertificateNo = enterprises.representativeCertificateNo.trim()"
                  [(ngModel)]="enterprises.representativeCertificateNo" #representativeCertificateNo="ngModel"
                  maxlength="20" [placeholder]="'form.certification_no' | translate" />
                <button mat-button *ngIf="enterprises.representativeCertificateNo" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.representativeCertificateNo=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error
                  *ngIf="representativeCertificateNo.invalid && representativeCertificateNo?.errors?.validInput">
                  {{'update_enterprise.validation.lbl_validation_gpkd_format' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Ngày cấp -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.representative_info.lbl_issued_date' | translate }}</mat-label>
                <input matInput [matDatepicker]="representativeIssuedDate1" [max]="maxDate"
                  (change)="this.commonService.resetDatePicker(pickerInput2.value, this.ngForm.controls['representativeIssuedDate'])"
                  name="representativeIssuedDate" #representativeIssuedDate="ngModel"
                  [(ngModel)]="enterprises.representativeIssuedDate" [ngClass]="{
                      'is-invalid': representativeIssuedDate.invalid
                    }" maxlength="20" #pickerInput2 (dateInput)="addEvent($event)" (dateChange)="addEvent($event)"
                  [placeholder]="'form.issued_date' | translate" />
                <mat-datepicker-toggle matSuffix [for]="representativeIssuedDate1"></mat-datepicker-toggle>
                <mat-datepicker #representativeIssuedDate1></mat-datepicker>
                <mat-error *ngIf="representativeIssuedDate.invalid">
                  {{ getErrorDateMessage(pickerInput2.value) }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Nơi cấp -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.representative_info.lbl_issued_by' | translate }}</mat-label>
                <input matInput type="text" name="representativeIssuedOn"
                  (focusout)="enterprises.representativeIssuedOn=enterprises.representativeIssuedOn.trim()"
                  [(ngModel)]="enterprises.representativeIssuedOn" maxlength="200"
                  [placeholder]="'form.issued_by' | translate" />
                <button mat-button *ngIf="enterprises.representativeIssuedOn" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.representativeIssuedOn=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Ngày sinh -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.representative_info.lbl_birthday' | translate }}</mat-label>
                <input matInput [max]="maxDate" [matDatepicker]="birthday1" [max]="maxDate"
                  (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['birthday'])"
                  name="birthday" [(ngModel)]="enterprises.birthday" #birthday="ngModel" #pickerInput1
                  (dateInput)="addEvent($event)" (dateChange)="addEvent($event)"
                  [placeholder]="'form.birthday' | translate" />
                <mat-datepicker-toggle matSuffix [for]="birthday1"></mat-datepicker-toggle>
                <mat-datepicker #birthday1></mat-datepicker>
                <mat-error *ngIf="birthday.invalid">{{getErrorDateMessage(pickerInput1.value)}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Giới tính -->
            <div class="col-md-4">
              <mat-label style="color: #858796">{{ 'update_enterprise.representative_info.cbx_sex.lbl_sex' | translate
                }}</mat-label><br>
              <mat-radio-group #sexSelect2 id="sex" name="sex" [(ngModel)]="enterprises.sex">
                <mat-radio-button [value]="true" class="pt-2 mr-3">{{'form.male' | translate}}</mat-radio-button>
                <mat-radio-button [value]="false">{{'form.female' | translate}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin liên hệ -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title" style="display: flex; justify-content: space-between;">
              {{'update_enterprise.contact_info.ttl_contact_info' | translate}}
              <small class="form-text text-gray pull-left pb-2 float-right">{{'update_enterprise.lbl_info' |
                translate}}
              </small>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row font-weight-bold">
            <div class="col-12">
              <div class="d-flex align-items-center">
                <div style="font-size: 15px; color:#000000DE" class="">{{'form.use_new_area' | translate}}</div>
                <div class="d-flex pl-2">
                  <div (click)="changeAddress(true)"
                    [ngClass]="enterprises.addresses[0].isNewAddress ? 'status-document' : 'text-off-document'"
                    style="cursor: pointer; border-right: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-left-radius: 3px; border-top-left-radius: 3px;">
                    {{'user_group.on_document' | translate}}</div>
                  <div (click)="changeAddress(false)"
                    [ngClass]="!enterprises.addresses[0].isNewAddress ? 'status-document' : 'text-off-document'"
                    style="cursor: pointer; border-left: none; font-weight: 600; border: 1px solid #D9D9D9; padding: 2px 10px; border-bottom-right-radius: 3px; border-top-right-radius: 3px;">
                    {{'user_group.off_document' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Tỉnh/Thành phố -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{'form.city' | translate}}</mat-label>
                <mat-select #citySelect (focusout)="(checkFocus = true)"
                  (focus)="commonService.openComboBox(checkFocus, citySelect)" id="cityId" name="cityId"
                  (selectionChange)="checkFocus = false; onChange($event.value, enterprises.addresses[0].isNewAddress ? 2 : 1);"
                  [(ngModel)]="enterprises.addresses[0].cityId" #cityId="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && cityId.invalid }" required maxlength="100">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="cityFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null" selected>{{'form.select_address' | translate}}</mat-option>
                  <mat-option *ngFor="let city of filteredCity | async" [value]="city.id"
                    (click)="this.commonService.closeDropdownList(this.citySelect)">
                    {{ city.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="f.submitted || cityId.invalid || cityId?.errors?.required">
                  {{'validation.city' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Quận/Huyện -->
            <div class="col-md-4" *ngIf="!enterprises.addresses[0].isNewAddress">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.contact_info.lbl_district' | translate }}</mat-label>
                <mat-select #districtSelect (focusout)="(checkFocus = true)"
                  (focus)="commonService.openComboBox(checkFocus, districtSelect)" id="districtId" name="districtId"
                  [(ngModel)]="enterprises.addresses[0].districtId" #districtId="ngModel" required
                  [ngClass]="{ 'is-invalid': districtId.invalid }"
                  (selectionChange)="checkFocus = false; onChange($event.value, 2);">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="districtsFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null" mat-selected>
                    {{ 'form.select_address' | translate }}
                  </mat-option>
                  <mat-option *ngFor="let district of filteredDistricts | async" [value]="district.id"
                    (click)="this.commonService.closeDropdownList(this.districtSelect)">
                    {{ district.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="districtId.invalid || districtId?.errors?.required">
                  {{'update_enterprise.validation.lbl_validation_district' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Phường/Xã-->
            <div class="col-md-4">
              <ng-container *ngIf="notHasWard; else hasWard">
                <mat-form-field class="w-100">
                  <mat-label>{{ 'update_enterprise.contact_info.lbl_ward' | translate }}</mat-label>
                  <mat-select (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, wardSelect1)" id="wardId" name="wardId"
                    [(ngModel)]="enterprises.addresses[0].wardId" #wardId="ngModel" #wardSelect1>
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate" [formControl]="wardFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null" mat-selected>
                      {{ 'form.select_address' | translate }}
                    </mat-option>
                    <mat-option *ngFor="let ward of  filteredWard | async" [value]="ward.id">
                      {{ ward.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-template #hasWard>
                <mat-form-field class="w-100">
                  <mat-label>{{ 'update_enterprise.contact_info.lbl_ward' | translate }}</mat-label>
                  <mat-select #wardSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, wardSelect)" id="wardId" name="wardId"
                    [(ngModel)]="enterprises.addresses[0].wardId" #wardId="ngModel" required
                    [ngClass]="{ 'is-invalid': wardId.invalid }">
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate" [formControl]="wardFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null" mat-selected>
                      {{ 'form.select_address' | translate }}
                    </mat-option>
                    <mat-option *ngFor="let ward of  filteredWard | async" [value]="ward.id"
                      (click)="this.commonService.closeDropdownList(this.wardSelect)">
                      {{ ward.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="wardId.invalid || wardId?.errors?.required">
                    {{ 'update_enterprise.validation.lbl_validation_ward' | translate }}
                  </mat-error>
                </mat-form-field>
              </ng-template>
            </div>

            <!-- Địa chỉ -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.contact_info.lbl_address' | translate }}</mat-label>
                <input matInput type="text" name="address" #address="ngModel"
                  (focusout)="enterprises.addresses[0].address=enterprises.addresses[0].address.trim()"
                  [(ngModel)]="enterprises.addresses[0].address" [ngClass]="{ 'is-invalid': address.invalid }" required
                  maxlength="200" [placeholder]="'form.address' | translate" />
                <button mat-button *ngIf="enterprises.addresses[0].address" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.addresses[0].address=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="address.invalid && address?.errors?.required">
                  {{ 'update_enterprise.validation.lbl_validation_address' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Số điện thoại -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.contact_info.lbl_phone' | translate }}</mat-label>
                <input matInput autocomplete="off" type="text" name="phoneNumber" #phoneNumber="ngModel"
                  (focusout)="enterprises.phone=enterprises.phone.trim()" [(ngModel)]="enterprises.phone" [maxlength]="maxLengthPhone" [pattern]="phonePattern2"
                  required [placeholder]="'form.phone' | translate" />
                <button mat-button *ngIf="enterprises.phone" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="enterprises.phone=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="phoneNumber.invalid && phoneNumber?.errors?.required">
                  {{'update_enterprise.validation.lbl_validation_phone' | translate}}
                </mat-error>
                <mat-error *ngIf="phoneNumber.invalid && phoneNumber?.errors?.pattern">
                  {{ 'update_enterprise.validation.lbl_validation_phone_format' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Email -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.contact_info.lbl_email' | translate }}</mat-label>
                <input matInput autocomplete="off" type="text" name="email" [(ngModel)]="enterprises.email"
                  (focusout)="enterprises.email=enterprises.email.trim()" #email="ngModel" [pattern]="emailPattern"
                  required [maxlength]="emailMaxlength" [placeholder]="'form.email' | translate" />
                <button mat-button *ngIf="enterprises.email" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="enterprises.email=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="email.invalid && email?.errors?.pattern">
                  {{ 'update_enterprise.validation.lbl_validation_email_format' | translate }}
                </mat-error>
                <mat-error *ngIf="email.invalid && email?.errors?.required">
                  {{ 'update_enterprise.validation.lbl_validation_email' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Fax -->
            <div class="col-md-4">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.contact_info.lbl_fax' | translate }}</mat-label>
                <input matInput type="text" name="fax" [(ngModel)]="enterprises.fax" #fax="ngModel" maxlength="20"
                  (focusout)="enterprises.fax=enterprises.fax.trim()" [placeholder]="'form.fax' | translate" />
                <button mat-button *ngIf="enterprises.fax" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="enterprises.fax=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="fax.invalid || fax?.errors?.validInput">
                  {{ 'update_enterprise.validation.lbl_validation_fax_format' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin thanh toán -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title" style="display: flex; justify-content: space-between;">
              {{'update_enterprise.pay_info.ttl_pay_info' | translate}}
              <small class="form-text text-gray pull-left pb-2 float-right">{{'update_enterprise.lbl_info' |
                translate}}
              </small>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row">
            <!-- Số tài khoản -->
            <div class="col-md-6">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.pay_info.lbl_accnumber' | translate }}</mat-label>
                <input matInput type="text" name="accountNumber" [(ngModel)]="enterprises.accountNumber"
                  (focusout)="enterprises.accountNumber=enterprises.accountNumber.trim()"
                  [maxlength]="accountNumberMaxlength" #accountNumber="ngModel"
                  [placeholder]="'form.accnumber' | translate" (input)="onlyNumber($event)"/>
                <button mat-button *ngIf="enterprises.accountNumber" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.accountNumber=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || accountNumber?.invalid || accountNumber?.errors?.validIp">
                  {{'validation.account_number' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Tên chủ tài khoản -->
            <div class="col-md-6">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.pay_info.lbl_accname' | translate }}</mat-label>
                <input matInput type="text" name="accountName" [(ngModel)]="enterprises.accountName"
                  (focusout)="enterprises.accountName=enterprises.accountName.trim()" [maxlength]="accountNameMaxlength"
                  [placeholder]="'form.accountName' | translate" />
                <button mat-button *ngIf="enterprises.accountName" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.accountName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <!-- Ngân hàng -->
            <div class="col-md-6">
              <!-- <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.pay_info.lbl_bank' | translate }}</mat-label>
                <input matInput type="text" name="bankName" [(ngModel)]="enterprises.bankName"
                  (focusout)="enterprises.bankName=enterprises.bankName.trim()" [maxlength]="bankMaxlength"
                  [placeholder]="'form.bank' | translate" />
                <button mat-button *ngIf="enterprises.bankName" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.bankName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field> -->

              <mat-form-field class="w-100">
                <mat-select #bankSelect (focusout)="(checkFocus = true)"
                  (focus)="commonService.openComboBox(checkFocus, bankSelect)" id="focusSelect" name="type"
                  (selectionChange)="checkFocus = false;"
                  [(ngModel)]="enterprises.bankName" #type="ngModel"
                  [placeholder]="'form.bank' | translate"
                >
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="bankFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null" mat-selected>{{'form.select_address' | translate}}</mat-option>
                  <mat-option *ngFor="let bankName of filteredBankName | async" [value]="bankName.key"
                    (click)="this.commonService.closeDropdownList(this.bankSelect)"
                    title="{{bankName.value}}">
                    {{bankName.value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Chi nhánh -->
            <div class="col-md-6">
              <mat-form-field class="w-100">
                <mat-label>{{ 'update_enterprise.pay_info.lbl_branch' | translate }}</mat-label>
                <input matInput type="text" name="bankBranch" [(ngModel)]="enterprises.bankBranch"
                  (focusout)="enterprises.bankBranch=enterprises.bankBranch.trim()" [maxlength]="bankMaxlength"
                  [placeholder]="'form.branch' | translate" />
                <button mat-button *ngIf="enterprises.bankBranch" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="enterprises.bankBranch=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
    <mat-hint class="hint-text" style="display: flex; justify-content: flex-start; color: red;">
      <!-- {{'update_enterprise.contact_change_information' | translate}} -->
      {{'update_enterprise.warning' | translate}}
    </mat-hint>
    <mat-card-actions class="text-center">
      <button mat-stroked-button color="primary" type="button" (click)="onNoClick()">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" class="mr-3 mat-raised-button mat-primary" type="submit" [disabled]="!isFormChanging">
        <mat-icon class="mr-0">save</mat-icon>
        {{'kyc.save_identify' | translate}}
      </button>

    </mat-card-actions>


  </mat-card>
</form>